export default __webpack_public_path__ + "static/media/content-deco-1.71615601.webp";